import { render, staticRenderFns } from "./BillingDetailsCard.vue?vue&type=template&id=8f3d853c"
import script from "./BillingDetailsCard.vue?vue&type=script&lang=js"
export * from "./BillingDetailsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports